<div class="new-recommendation">
  <!--   F r o m :     S e l e c t   -->
  <mat-form-field appearance="fill" class="row-field">
    <mat-label>Recommended By</mat-label>
    <mat-select name="From" [value]="newRecommendation().from" (selectionChange)="onUserSelectChange($event, 'from')">
      @for ( user of allUsers; track user) {
      <mat-option [value]="user">{{ user }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
<!--   T o :    S e l e c t   -->
  <mat-form-field appearance="fill" class="row-field">
    <mat-label>Recommended To</mat-label>
    <mat-select name="To" [value]="newRecommendation().to" (selectionChange)="onUserSelectChange($event, 'to')">
      @for ( user of allUsers; track user) {
      <mat-option [value]="user">{{ user }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button mat-mini-fab color="primary" matTooltip="Add Recommendation" (click)="addRecommendation()">
    <mat-icon fontIcon="add_circle" ></mat-icon>
  </button>
  <button mat-mini-fab color="primary" matTooltip="Cancel" (click)="clearRecommendation()">
    <mat-icon fontIcon="cancel"></mat-icon>
  </button>

</div>